import { render, staticRenderFns } from "./PageExchangeForm.vue?vue&type=template&id=0c196446&scoped=true"
import script from "./PageExchangeForm.vue?vue&type=script&lang=js"
export * from "./PageExchangeForm.vue?vue&type=script&lang=js"
import style0 from "./PageExchangeForm.vue?vue&type=style&index=0&id=0c196446&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c196446",
  null
  
)

export default component.exports